import { FormPositions } from "../components/FormPositions";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const CreatePosition: React.FC = () => {
  const isSyncActive = useSyncActive();

  return (
    <div>
      <FormPositions pageType="create" isSyncActive={isSyncActive} />
    </div>
  );
};